import React from 'react';
import '../styles/SectionTitle.css';

/**
 * SectionTitle
 * Props:
 *  tag      {string}  – small eyebrow label
 *  heading  {node}    – main heading (can contain <em>)
 *  center   {bool}    – center-align
 *  noLine   {bool}    – hide gold line
 *  sub      {string}  – optional sub paragraph
 */
const SectionTitle = ({ tag, heading, center = false, noLine = false, sub, style, color }) => {
  const cls = ['section-title-block', center ? 'section-title-block--center' : ''].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      {tag && <span className="section-tag">{tag}</span>}
      <h2
        className="section-heading"
        style={{ color: color || undefined, ...style }}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
      {!noLine && <div className="section-line" />}
      {sub && (
        <p
          style={{
            color: color ? color : 'rgba(59, 59, 59, 0.7)',
            fontSize: 14,
            lineHeight: 2,
            ...style
          }}
        >
          {sub}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;